<!--
 * @Description: 订单跟踪抽屉页面
 * @Author: sunhuihong
 * @Date: 2024-06-04 16:43:52
-->
<template>
  <el-drawer title="订单跟踪" :visible.sync="visible" direction="rtl" size="800px" 
    @open="initData" :before-close="handleClose">
    <div class="order-progress-body">
      <div class="order-msg">
        <el-descriptions title="" :column="6" direction="vertical">
          <el-descriptions-item :span="2" label="订单号">{{orderData.orderNo || '- -'}}</el-descriptions-item>
          <el-descriptions-item :span="2" label="下单人">{{orderData.createOrderUserInfo || '- -'}}</el-descriptions-item>
          <el-descriptions-item :span="2" label="下单时间">{{orderData.orderGenTime || '- -'}}</el-descriptions-item>
          <el-descriptions-item :span="2" label="支付方式">
            {{orderData.payWayText}}
            <span v-if="orderData.paymentModeText">
              {{orderData.payWayText ? ('- ' + orderData.paymentModeText) :  orderData.paymentModeText}}
            </span>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="订单状态">{{orderData.statusText || '- -'}}</el-descriptions-item>
          <el-descriptions-item :span="2" label="订单来源">{{orderData.sourceText || '- -'}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="order-progress-content">
        <div class="section-item-head">
          <img src="@/assets/common/icon-common-vertical-line.png" alt=""
            class="vertical-line-img">
		    	<span>订单执行进度</span>
		    </div>   
        <div class="order-progress-list">
          <el-timeline>
            <el-timeline-item v-for="(item, index) in orderProgressList"
              :key="index" :color="index == orderProgressList.length - 1 ? '#3377FF' : '#D9E5FF'">
              <div class="timeline-title">{{item.resultMsg}}</div>
              <div class="timeline-time">{{rebuildDate(item.startTime)}}</div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </div>
    <div class="bk-wizard-bottons">
      <el-button @click="handleClose">关 闭</el-button>
    </div>
  </el-drawer>
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
  name: 'OrderProgress',
  props: ["visible", "orderId"],

  data() {
    return {
      orderData: {},
      orderProgressList: []
    }
  },

  methods: {
    initData() {
      let params = {orderId: this.orderId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_LIST_ORDER_PROGRESSES,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.orderData = result.data || {};
        this.orderProgressList = result.data.orderProgressList || [];
      })
    },

    rebuildDate(date) {
      if (!date) return;
      return this.dateUtil.dateTimeFormat(date, "YYYY-MM-DD HH:mm");
    },

    handleClose() {
      this.$emit("close-drawer");
    } 
  }
}
</script>

<style scoped>
.order-progress-body {
  min-height: 90vh;
  position: relative;
  padding: 29px 30px;
}

.order-msg {
  padding: 20px 38px;
  background: #F3F7FA;
}

.order-progress-content {
  margin: 20px 0 0 0;
}

.order-progress-content .section-item-head {
  display: flex;
  align-items: center;
  text-align: left;
}

.order-progress-content .section-item-head span {
  font-weight: 600;
  font-size: 15px;
  color: #000000;
}

.order-progress-content .vertical-line-img {
  width: 5px;
  height: 20px;
  margin-right: 9px;
}

.order-progress-list {
  text-align: left;
  margin-top: 20px;
}

.timeline-title {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}

.timeline-time {
  font-weight: 400;
  font-size: 12px;
  color: #929498;
  line-height: 17px;
}
</style>
<style>
.order-msg .el-descriptions__body {
  background: #F3F7FA !important;
}

.order-msg .el-descriptions-item__label {
  color: #7C899A !important;
  font-size: 15px !important;
}

.order-msg .el-descriptions-item__content {
  color: #000000 !important;
  font-size: 15px !important;
  font-weight: 600 !important;
}

.order-progress-list ul {
  padding: 0 0 0 5px!important;
}
</style>


// WEBPACK FOOTER //
// src/components/ordermng/components/OrderProgress.vue